import React, { useState } from 'react';

const LunchboxMenu = ({ menuData, date }) => {
  const [showMenu, setShowMenu] = useState(false);

  if (!menuData) {
    return (
      <div className="lunchbox-menu">
        <div className="menu-header">
          <h4>當日餐單</h4>
          <button 
            className="toggle-btn"
            onClick={() => setShowMenu(!showMenu)}
          >
            {showMenu ? '隱藏餐單' : '顯示餐單'}
          </button>
        </div>
        <div className="no-menu">
          <p>暫無餐單資料</p>
        </div>
      </div>
    );
  }

  if (menuData.is_holiday) {
    return (
      <div className="lunchbox-menu">
        <div className="menu-header">
          <h4>當日餐單</h4>
          <button 
            className="toggle-btn"
            onClick={() => setShowMenu(!showMenu)}
          >
            {showMenu ? '隱藏餐單' : '顯示餐單'}
          </button>
        </div>
        {showMenu && (
          <div className="holiday-notice">
            <p>是日不用訂餐</p>
          </div>
        )}
      </div>
    );
  }

  const menuTypes = [
    {
      type: 'A',
      name: '家常風味',
      color: 'orange',
      icon: '🍳',
      menu: menuData.type_a_menu
    },
    {
      type: 'B',
      name: '特式風味',
      color: 'blue',
      icon: '🍽️',
      menu: menuData.type_b_menu
    },
    {
      type: 'C',
      name: '至營推介',
      color: 'red',
      icon: '❤️',
      menu: menuData.type_c_menu
    },
    {
      type: 'D',
      name: '健康素食',
      color: 'green',
      icon: '🌱',
      menu: menuData.type_d_menu
    }
  ];

  return (
    <div className="lunchbox-menu">
      <div className="menu-header">
        <h4>當日餐單</h4>
        <button 
          className="toggle-btn"
          onClick={() => setShowMenu(!showMenu)}
        >
          {showMenu ? '隱藏餐單' : '顯示餐單'}
        </button>
      </div>
      
      {showMenu && (
        <div className="menu-content">
          <div className="menu-grid">
            {menuTypes.map((menuType) => (
              <div key={menuType.type} className={`menu-card ${menuType.color}`}>
                <div className="menu-card-header">
                  <span className="menu-icon">{menuType.icon}</span>
                  <div className="menu-type-info">
                    <h5>類型 {menuType.type}</h5>
                    <h6>{menuType.name}</h6>
                  </div>
                </div>
                <div className="menu-dish">
                  <p>{menuType.menu}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default LunchboxMenu;
